module.exports = {
	"client": "alo-opc",
	"client_fullname": "Advance Local Media",
	"version": "1.0.2.14",
	"production_url": "alo-opc-webreader-production.twipemobile.com",
	"uat_url": "alo-opc-webreader-uat.twipemobile.com",
	"production_api": "alo-opc-production-backend-api.twipecloud.net",
	"uat_api": "alo-opc-uat-backend-api.twipecloud.net",
	"html_title": "The Oregonian",
	"nextgen": true,
	"replica": true
};


//////////////////
// WEBPACK FOOTER
// ./clients/ALO-OPC/package.json
// module id = 123
// module chunks = 0 1